import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-brand">
            <span className="footer-logo">Mindmark</span>
            <p className="footer-disclaimer">
              Mindmark is an independent AI tool and is not affiliated with, endorsed by, or associated with AHPRA. It does not replace professional legal advice.
            </p>
            <p className="footer-copyright">
              &copy; {new Date().getFullYear()} Mindmark. All rights reserved.
            </p>
          </div>

          <div className="footer-links">
            <div className="footer-column">
              <Link to="/legal" className="footer-column-title-link">Legal</Link>
              <Link to="/terms" className="footer-link">Terms of Use</Link>
              <Link to="/privacy" className="footer-link">Privacy Policy</Link>
              <Link to="/disclaimer" className="footer-link">Disclaimer</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
